import { substringAfter } from '@edicom/common/string/substringAfter.js';
import { substringBefore } from '@edicom/common/string/substringBefore.js';

const FIELD_SEPARATOR = ',';
const ATTR_SEPARATOR = '=';

/**
 * Extract data field
 *
 * @param {*} data
 * @param {*} attribute
 * @returns
 */
export function getCertDataField(data, attribute) {
  const find = data?.split(FIELD_SEPARATOR).find((attr) => substringBefore(attr, ATTR_SEPARATOR)?.trim() === attribute);
  return substringAfter(find || '', ATTR_SEPARATOR);
}
